export const CROSS_BORDER_REQUIRED_SECTIONS = [
  'drsIssued',
  'drsIssuedTrans',
  'drsCancelled',
  'drsCancelledTrans',
  'netIssueCancel',
  'totalCrossBorderTrading'
];

export const isCrossBorderDataSectionSelected = (
  sections: Array<{ name: string; isSelected: boolean }> | undefined
): boolean => {
  if (!sections) return false;

  return sections.some(section => CROSS_BORDER_REQUIRED_SECTIONS.includes(section.name) && section.isSelected);
};
